import React from "react";
import { FaArrowRight } from "react-icons/fa6";

const AboutSection = () => {
  return (
    <section id="about-us">
      <div className="row align-items-center mx-0">
        <div className="col-md-6 pe-md-4 about_bg"></div>
        <div className="col-md-6">
          <div className="px-md-5 px-4 py-4">
            <div>
              <h3 className="display-6 fw-bold text-capitalize">
                Why Choose Zithas Technologies?
              </h3>
            </div>
            <div className="pt-4">
              <p className="paragraph d-flex">
                <div>
                  <FaArrowRight className="me-3 text-red" />
                </div>
                <div>
                  <b>Construction-Focused Expertise: </b> We understand your operational pain points, deadlines, and compliance requirements.
                </div>
              </p>

              <p className="paragraph d-flex">
                <div>
                  <FaArrowRight className="me-3 text-red" />
                </div>
                <div>
                  <b>Full Lifecycle Support: </b> From planning through to post-launch maintenance.
                </div>
              </p>

              <p className="paragraph d-flex">
                <div>
                  <FaArrowRight className="me-3 text-red" />
                </div>
                <div>
                  <b>Security & Reliability: </b> All solutions comply with GDPR and industry-specific regulations.
                </div>
              </p>

              <p className="paragraph d-flex">
                <div>
                  <FaArrowRight className="me-3 text-red" />
                </div>
                <div>
                  <b>Flexible & Scalable Systems: </b> Start with a core feature set and scale as your business grows.
                </div>
              </p>

              <p className="paragraph d-flex">
                <div>
                  <FaArrowRight className="me-3 text-red" />
                </div>
                <div>
                  <b>Measurable ROI: </b> Clients report faster payments, fewer delays, and higher client retention.
                </div>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;